import { GET, httpOk } from 'helpers/api'
import { formatDate, formatMoney } from 'helpers/helpers';
import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next';

function Movements({ modal, setModal, id }) {
    const { t } = useTranslation();


    const [data, setData] = useState([])

    useEffect(() => {
        async function getData() {
            const response = await GET(`/inventory/movements/`, { product_id: id })
            if (httpOk(response)) {
                setData(response.data)
            }
        }

        if (modal && id) {
            getData()
        } else {
            setData([])
        }
    }, [modal, id]);

    return (
        <>
            <Modal show={modal} centered onHide={() => setModal(false)} dialogClassName="second">
                <i className="uil-times" onClick={() => setModal(false)}></i>
                <div className="modal-title mb-12">
                    {t('movements')}
                </div>
                <div className="modal-subtitle mb-32">
                    {t('view_all_product_movements')}
                </div>

                <div className="table-responsive">
                    <table className="table">
                        <thead>
                            <tr>
                                <th style={{ width: '20%' }}>{t('name')}</th>
                                <th style={{ width: '10%' }}>{t('balance')}</th>
                                <th style={{ width: '10%' }}>{t('min_balance')}</th>
                                <th style={{ width: '10%' }}>{t('unit_short')}</th>
                                <th style={{ width: '10%' }}>{t('type')}</th>
                                <th style={{ width: '10%' }}>{t('created_at')}</th>
                            </tr>
                        </thead>

                        <tbody>
                            {data?.results?.map((item, index) => (
                                <tr key={index}>
                                    <td>{item.item_name}</td>
                                    <td>{formatMoney(item.quantity)}</td>
                                    <td>{formatMoney(item.min_level)}</td>
                                    <td>{item.unit_short_name}</td>
                                    <td>{t(item.movement_type)}</td>
                                    <td>{formatDate(item.created_at)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <div className="modal-footer">
                    <button className="white" onClick={() => setModal(false)}>
                        {t('cancel')}
                    </button>
                </div>
            </Modal>
        </>
    )
}

export default Movements